module.exports = __webpack_public_path__ + "static/media/lds-logo_bg.ab5dee02.svg";